// src/components/MainRouterPage.js
import React, { useState, useContext } from 'react';
import { AuthContext } from '../App';
// import InventoryDashboard from './InventoryDashboard';
import config from "../config";   // <-- FIXED

// --- Basic Styling ---
const routerPageStyles = {
    fontFamily: 'Arial, sans-serif',
    maxWidth: '800px',
    margin: '20px auto',
    padding: '20px',
    border: '1px solid #ddd',
    borderRadius: '8px',
    boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
    textAlign: 'center',
};

const navButtonStyles = {
    padding: '10px 20px',
    margin: '10px',
    borderRadius: '5px',
    border: 'none',
    backgroundColor: '#007bff',
    color: 'white',
    fontSize: '1.1em',
    cursor: 'pointer',
};

const logoutButtonStyles = {
    padding: '10px 15px',
    borderRadius: '4px',
    border: 'none',
    cursor: 'pointer',
    backgroundColor: '#dc3545',
    color: 'white',
    fontSize: '1em',
    marginTop: '20px',
};

export default function MainRouterPage() {
    const { currentUser, userRoles, logout } = useContext(AuthContext);
    const [currentModule, setCurrentModule] = useState(null);

    const hasRole = (role) => userRoles.includes(role);

    if (!currentUser) {
        return <p>Not authenticated.</p>;
    }

    return (
        <div style={routerPageStyles}>
            <h1>Welcome, {currentUser.email}!</h1>
            <p>Your Roles: {userRoles.join(', ')}</p>
            <h2>Available Modules:</h2>

            {hasRole('inventory_manager') && (
                <a href={config.inventoryUrl} style={{ textDecoration: 'none' }}>
                    <button style={navButtonStyles}>
                        Inventory Management (Warehousing)
                    </button>
                    Go to InventoryStream
                </a>
            )}

            {hasRole('purchasing_agent') && (
                <button disabled style={{ ...navButtonStyles, opacity: 0.6, cursor: 'not-allowed' }}>
                    Purchasing (Coming Soon)
                </button>
            )}

            {hasRole('logistics_manager') && (
                <button disabled style={{ ...navButtonStyles, opacity: 0.6, cursor: 'not-allowed' }}>
                    Logistics (Coming Soon)
                </button>
            )}

            {!hasRole('approved_user') && userRoles.includes('pending') && (
                <p style={{ marginTop: '20px', color: '#856404' }}>
                    You are an approved user, but currently have no specific access roles assigned.  
                    Please contact your administrator.
                </p>
            )}

            <button onClick={logout} style={logoutButtonStyles}>Log Out</button>
        </div>
    );
}